export enum InternationalInsuranceVehicleFormatEnum {
    Email = 'Email',
    Pdf = 'Pdf',
}
